export default __webpack_public_path__ + "static/media/favicon.5ef87ca9.webp";